import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M11.8 33.4c0-.8-.1-1.5-.3-2h1.7l-3.1-5.3L7 31.4h1.8c.3.5.4 1.1.4 2 0 1.2-.3 1.7-.7 2.4-.4.8-1 1.8-1 3.6s.5 2.8 1 3.6c.1.3.3.5.4.7h2.6c0-.1 0-.2-.1-.4-.2-.6-.5-1.1-.7-1.6-.4-.7-.7-1.2-.7-2.4s.3-1.7.7-2.4c.5-.7 1.1-1.7 1.1-3.5z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M24.1 33.4c0-.8-.1-1.5-.3-2h1.7l-3.1-5.3-3.1 5.3h1.8c.3.5.4 1.1.4 2 0 1.2-.3 1.7-.7 2.4-.4.8-1 1.8-1 3.6s.5 2.8 1 3.6c.1.3.3.5.4.7h2.6c0-.1 0-.2-.1-.4-.2-.6-.5-1.1-.7-1.6-.4-.7-.7-1.2-.7-2.4s.3-1.7.7-2.4c.6-.7 1.1-1.7 1.1-3.5z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M36.5 33.4c0-.8-.1-1.5-.3-2H38l-3.1-5.3-3.1 5.3h1.8c.3.5.4 1 .4 2 0 1.2-.3 1.7-.7 2.4-.4.8-1 1.8-1 3.6s.5 2.8 1 3.6c.1.3.3.5.4.7h2.6c0-.1 0-.2-.1-.4-.2-.6-.5-1.1-.7-1.6-.4-.7-.7-1.2-.7-2.4s.3-1.7.7-2.4c.4-.7 1-1.7 1-3.5z"
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M42 2.5c.3 0 .5.2.5.5v39c0 .3-.2.5-.5.5H3c-.3 0-.5-.2-.5-.5V3c0-.3.2-.5.5-.5h39M42 0H3C1.3 0 0 1.3 0 3v39c0 1.7 1.3 3 3 3h39c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.8,
			y: 21.2,
			className: "icon-fill-primary",
			width: 42.6,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M39.2 17.7H27.9v-1.2c0-1.2-1-2.1-2.1-2.1h-6.5c-1.2 0-2.1 1-2.1 2.1v1.2H5.8V6.4h11.3v1.2c0 1.2 1 2.1 2.1 2.1h6.5c1.2 0 2.1-1 2.1-2.1V6.4h11.3v11.3zm-9-2.5h6.5V8.9h-6.5c-.4 1.5-1.5 2.7-3 3.1 1.5.5 2.6 1.7 3 3.2zm-21.9 0h6.5c.4-1.5 1.5-2.7 3-3.1-1.4-.5-2.6-1.7-3-3.1H8.3v6.2z"
		})
	]
});
export default SvgIcon;
